import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NominasEspeciales } from '../../../../models/nominasEspeciales';
import { ConfigDataService } from '../../../../services/config-data.service';
import { CodigosNominaService } from '../../../../services/codigosNomina.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-nominas-especiales-detalle',
  templateUrl: './nominas-especiales-detalle.component.html',
  styleUrls: ['./nominas-especiales-detalle.component.css']
})
export class NominasEspecialesDetalleComponent implements OnInit, AfterViewInit {

  monedasList: any;
  codigosNominaList: any;
  motivosList: any;

  constructor(private configDataSrv: ConfigDataService,
              private codigosNominaService: CodigosNominaService,
              private fb: FormBuilder,
              private momentService: MomentSetService) { }

  @Input() set nominaEspecial(nominaRecibida: NominasEspeciales)
  {
    this.nominaEspecialForm = nominaRecibida;
    this.setearForm(nominaRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() nominasInvalida: boolean;

  form: FormGroup;
  nominaEspecialForm: NominasEspeciales;
  actualizarFormatoInputNumerico = false;
  NominaList: any
  submitted: boolean;
  tipoCarga: number;

  ngOnInit(): void
  {
    this.tipoCarga = 0;
    
    this.configDataSrv.getDatosNominas()
      .subscribe(
        data => {
          this.monedasList=data["Monedas"];
          this.motivosList=data["MotivoNominaEspecial"];
        },
        error => {
          console.log(error);
        });
    
    this.codigosNominaService.getAll().subscribe(
      codigos => 
      { 
        codigos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        
        this.NominaList = codigos;
        this.cargaConceptos();
      });
    
    this.configurarValidadores();
    this.setearForm(this.nominaEspecialForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      fecha: ['', Validators.required],
      codigosNomina: ['', Validators.required],
      motivoNominaEspecial: ['', Validators.required],
      cantidad: [''],
      importe: [''],
      moneda: ['']
    });

  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(nomina: NominasEspeciales)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(nomina?.id);
      this.form.controls['personal'].setValue(nomina?.personal);
      this.form.controls['fecha'].setValue(new Date(nomina?.fecha));
      this.form.controls['cantidad'].setValue(nomina?.cantidad);
      this.form.controls['motivoNominaEspecial'].setValue(nomina?.motivoNominaEspecial);
      this.form.controls['codigosNomina'].setValue(nomina?.codigosNomina);
      this.form.controls['importe'].setValue(nomina?.importe);
      this.form.controls['moneda'].setValue(nomina?.moneda);

      if (nomina.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }

      this.getTipoCargaCodigoNomina(this.nominaEspecialForm.codigosNomina);
    }
  }

  ngAfterViewInit()
  {
    if (this.form.controls['id'].value != "0")
    {
      this.form.controls['importe'].setValue(this.nominaEspecialForm?.importe);
      this.actualizarFormatoInputNumerico = true;
    }
  }

  onChangeCodigoNomina(event)
  {
    this.getTipoCargaCodigoNomina(event.value);
    if (this.tipoCarga == 2) 
    {
      this.form.controls['importe'].setValue(0);
      this.form.controls['moneda'].setValue(1);
    } else if (this.tipoCarga == 1)
    {
      this.form.controls['cantidad'].setValue(0);
    } else if (this.tipoCarga == 4)
    {
      this.form.controls['importe'].setValue(0);
      this.form.controls['moneda'].setValue(1);
      this.form.controls['cantidad'].setValue(0);
    }
    let unidadMedida = this.codigosNominaList.find(c => c.id == event.value).um;
  }

  getTipoCargaCodigoNomina(nomina:number){
    this.tipoCarga = 0;
    if (nomina != null) {
      this.tipoCarga = this.codigosNominaList.find(m => m.id == nomina).tipoCarga;
    }
    if (this.tipoCarga == 2) 
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('moneda', null);
      this.setValidatorRequired('cantidad', Validators.required);
    } else if (this.tipoCarga == 1)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('moneda', Validators.required);
      this.setValidatorRequired('cantidad', null);
    } else if (this.tipoCarga == 3)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('cantidad', Validators.required);
      this.setValidatorRequired('moneda', Validators.required);
    } else
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('moneda', null);
      this.setValidatorRequired('cantidad', null);
    }
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  onChangeFechas()
  {
    this.cargaConceptos();
  }

  cargaConceptos()
  {
    //Carga los conceptos validos
    let fecha = this.form.get("fecha").value.toDateString();
    let concepto = this.form.get("codigosNomina").value;

    this.codigosNominaList = this.NominaList && this.NominaList.filter(items => items.nominaEspecial == true &&
                                                                                Date.parse(items.desde) <= Date.parse(fecha) &&
                                                                                Date.parse(items.hasta) >= Date.parse(fecha)) ;
    
    let index = this.codigosNominaList.findIndex(x => x.id == concepto)
    if (index == -1)
    {
      //No existe en la nueva lista, lo limpio
      this.form.controls['codigosNomina'].setValue(null);
    }
  }
}

